




















import Vue from 'vue';
import ContentButtons from './ContentButtons.vue';
import ContentTable from './ContentTable.vue';

export default Vue.extend({
  components: { ContentButtons, ContentTable },
  props: {
    bots: {
      type: Array,
    },
    botsCount: {
      type: Number,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
});
